import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'pt-writer-permission-help',
  template: `
    <div>
      <span><b>{{'USER_PERMISSIONS.WRITER.INTRODUCTION' | translate}}:</b></span>
      <ul class="m-0">
        <li>{{'USER_PERMISSIONS.WRITER.CAN_READ_ALL' | translate}}</li>
        <li>{{'USER_PERMISSIONS.WRITER.CAN_CRATE_DOCUMENTS' | translate}}</li>
        <li>{{'USER_PERMISSIONS.WRITER.CAN_DELETE_DOCUMENTS_NOT_VALIDATED' | translate}}</li>
      </ul>
    </div>
  `
})
export class WriterPermissionHelpComponent {
  constructor(public translate: TranslateService) {
  }
}
